// extracted by mini-css-extract-plugin
export var collapsedSummary = "_kn-0";